import { Shield, Star, Clock, Leaf } from 'lucide-react';

const badges = [
  { Icon: Shield, label: 'Licensed & Insured' },
  { Icon: Star, label: 'Experienced Team' },
  { Icon: Clock, label: 'Reliable & On Time' },
  { Icon: Leaf, label: 'Eco-Friendly Products' }
];

export const TrustBadges = () => (
  <section className="bg-[#0F172A] py-4 sm:py-5">
    <div className="container mx-auto px-4 sm:px-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 text-white text-center">
        {badges.map((badge, i) => (
          <div key={i} className="flex items-center justify-center gap-2">
            <badge.Icon size={18} className="text-[#4CAF50] flex-shrink-0" />
            <span className="text-xs sm:text-sm font-medium">{badge.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
